import { NoteAdd, Add } from '@/components/icons';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface BuilderFloatingToolbarProps {
    disabled?: boolean;
    onAddQuestion: () => void;
    onAddSection: () => void;
}

export function BuilderFloatingToolbar({
    disabled,
    onAddQuestion,
    onAddSection,
}: BuilderFloatingToolbarProps) {
    return (
        <div className="pointer-events-none fixed left-[calc(50%+34rem)] top-32 z-20 hidden xl:block">
            <TooltipProvider delayDuration={150}>
                <div className="pointer-events-auto flex flex-col gap-2 rounded-2xl border border-border bg-card p-2 shadow-elevation-2">
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Button
                                type="button"
                                size="icon"
                                onClick={onAddQuestion}
                                disabled={disabled}
                                aria-label="Adicionar pergunta"
                            >
                                <Add className="size-4" />
                            </Button>
                        </TooltipTrigger>
                        <TooltipContent side="left">Adicionar pergunta</TooltipContent>
                    </Tooltip>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Button
                                type="button"
                                variant="surface"
                                size="icon"
                                onClick={onAddSection}
                                disabled={disabled}
                                aria-label="Adicionar seção"
                            >
                                <NoteAdd className="size-4" />
                            </Button>
                        </TooltipTrigger>
                        <TooltipContent side="left">Adicionar seção</TooltipContent>
                    </Tooltip>
                </div>
            </TooltipProvider>
        </div>
    );
}
